export default "__VITE_ASSET__e31df6ca__"